import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from '@app/layouts';

export const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./domains/landing/routes').then(m => m.routes),
      },
      {
        path: 'careers',
        loadChildren: () =>
          import('./domains/careers/routes').then(m => m.routes),
      },
      {
        path: 'compare',
        loadChildren: () =>
          import('./domains/compare/routes').then(m => m.routes),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./domains/contact/routes').then(m => m.routes),
      },
      {
        path: 'enterprise',
        loadChildren: () =>
          import('./domains/enterprise/routes').then(m => m.routes),
      },
      {
        path: 'live-updates',
        loadChildren: () =>
          import('./domains/live-updates/routes').then(m => m.routes),
      },
      {
        path: 'native-builds',
        loadChildren: () =>
          import('./domains/native-builds/routes').then(m => m.routes),
      },
      {
        path: 'app-store-publishing',
        loadChildren: () =>
          import('./domains/app-store-publishing/routes').then(m => m.routes),
      },
      {
        path: 'newsletter',
        loadChildren: () =>
          import('./domains/newsletter/routes').then(m => m.routes),
      },
      {
        path: 'partners',
        loadChildren: () =>
          import('./domains/partners/routes').then(m => m.routes),
      },
      {
        path: 'pricing',
        loadChildren: () =>
          import('./domains/pricing/routes').then(m => m.routes),
      },
      {
        path: 'tools',
        loadChildren: () =>
          import('./domains/tools/routes').then(m => m.routes),
      },
      {
        path: 'trust',
        loadChildren: () =>
          import('./domains/trust/routes').then(m => m.routes),
      },
      {
        path: '**',
        loadChildren: () =>
          import('./domains/not-found/routes').then(m => m.routes),
      },
    ],
  },
];
